module.exports = __webpack_public_path__ + "static/media/forbexLogo.ca038411.png";